import { logUncaught } from 'utils/log';
import {
  request as realRequest,
  postRequest as realPostRequest,
} from '@quintoandar/fwp-fetch';


export function request(...args) {
  try {
    return realRequest(...args);
  } catch (e) {
    logUncaught(e, {
      args,
    });
    throw e;
  }
}

export function postRequest(...args) {
  try {
    return realPostRequest(...args);
  } catch (e) {
    logUncaught(e, {
      args,
    });
    throw e;
  }
}
